import './index.scss';
import React from 'react';
import PDFViewer from '~/components/old_pdf_viewer';
import clausesToBookmarks from '~/utils/clausesToBookmarks';
const DocView = ({ activeClauseIds, areComparisonDocumentsLoading, document, setDocHasRendered, type }) => {
    if (document === undefined || areComparisonDocumentsLoading) {
        return (React.createElement("span", null,
            React.createElement("i", { className: 'fas fa-spin fa-spinner' })));
    }
    const allBookmarks = clausesToBookmarks(document.classifications);
    const bookmarks = allBookmarks.filter(bookmark => bookmark.id === activeClauseIds.anchorClause ||
        bookmark.id === activeClauseIds.comparatorClause);
    return (React.createElement(PDFViewer, { document: document, bookmarks: bookmarks, setIsDocumentRendered: setDocHasRendered, type: type }));
};
export default DocView;
